import { siteMap } from "internal-sitemap";
import React from "react";
import { Redirect } from "react-router";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import { RouteDefinition } from "utilities/interfaces/route-definition";
import { RouteUtils } from "utilities/route-utils";
import {
    NestedRoutes,
    NestedRoutesProps,
} from "utilities/routing/nested-route";

const DemoLayout: React.FC<any> = (props: NestedRoutesProps) => {
    // Prevent real customers from viewing demo pages
    const { currentIdentity } = useCurrentIdentity();
    if (currentIdentity && !currentIdentity?.isAdmin()) {
        return <Redirect to={siteMap.errors.notFound} />;
    }

    return (
        <NestedRoutes
            routes={props.routes.map((route: RouteDefinition) =>
                RouteUtils.withCulture<RouteDefinition>(route)
            )}
        />
    );
};

export default DemoLayout;
